import { env } from './env'

export const LOCAL_STORAGE_KEY = 'atlascloud-user-ls'

export const server = `${env.backendUrl}/`

export const colors = {
  darkGrey1: '#0d1117',
  darkGrey2: '#21262d',
  darkGrey3: '#30363d',
  mediumGrey1: '#484f58',
  blue1: '#0b949e',
  blue2: '#79c9ff',
  blue3: '#1f6feb',
  orange1: '#ffa557',
  red1: '#f85149',
  green1: '#3fb950',
  green2: '#7ee787',
  green3: '#aff5b4',
  lightGrey1: '#c9d1d9',
  white: '#ffffff',
  black: '#000000',
  //
  bgGray: '#FCFCFD',
  gray200: '#F2F4F7',
  gray300: '#E4E7EC',
  gray400: '#D0D5DD',
  gray500: '#98A2B3',
  gray600: '#667085',
  gray700: '#101828',
  blackAlpla300: 'rgba(18,18,18,0.5)',
  primary100: '#F0F5FF',
  primary200: '#9EC8F1',
  primary300: '#3D90E3',
  primary400: '#0354A6',
  error100: '#FDE1E1',
  error200: '#FCA5A5',
  error300: '#BB251A',
  error400: '#912018',
  info100: '#DCEDFC',
  info400: '#0F4E8C',
}

export const measurments = {
  contentWidth: 1000,
  navWidth: 1200,
  navHeight: 50,
  borderRadius: 4,
  borderRadiusLarge: 8,
  toolbarWidth: 250,
  internalNavWidth: 250,
}

export const breakPoints = {
  tablet: 768,
  mobile: 400,
}

export const breakPointsCss = {
  tablet: `@media(max-width: 768px)`,
  moblie: `@media(max-width: 400px)`,
}
